module.exports = __webpack_public_path__ + "img/49_18.26caa449.png";